export const T = {
  // Palette
  bg: "#F7F8FA",
  surface: "#FFFFFF",
  border: "#DDE1EA",
  borderStrong: "#BFC5D0",
  // Blues
  accent: "#1A4ED8",
  accentLight: "#EBF0FD",
  accentMid: "#C7D5FA",
  // Text
  textPrimary: "#0F1623",
  textSecondary: "#5A6478",
  textMuted: "#8B94A6",
  // Row tints
  groupBg: "#F0F2F7",
  typePriceBg: "#F7F8FA",
  dragBg: "#C7D5FA",
  editedBg: "#FFFBEB",
  inheritBg: "#F0FDF4",
  roomEditBg: "#EBF4FF",
  // Tags
  tagOrange: "#D97706",
  tagGreen: "#059669",
  tagBlue: "#1A4ED8",
  // Accent stripe
  stripe: "#1A4ED8",
};


export const S = {
  pageHeader: {
    marginBottom: 16,
  },
  breadcrumb: {
    display: "flex", alignItems: "center", gap: 6,
    marginBottom: 6,
  },
  breadSep: { color: T.textMuted, fontSize: 11 },
  breadItem: { fontSize: 12, color: T.textSecondary },
  pageTitle: {
    margin: 0, fontSize: 22, fontWeight: 700, color: T.textPrimary, letterSpacing: "-0.3px",
  },
  pageSubtitle: {
    margin: "4px 0 0", fontSize: 13, color: T.textSecondary,
  },

  card: {
    background: T.surface,
    borderRadius: 8,
    border: `1px solid ${T.border}`,
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(15,22,35,0.06), 0 0 0 1px rgba(15,22,35,0.04)",
  },

  toolbar: {
    height: 52,
    padding: "0 16px",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    borderBottom: `1px solid ${T.border}`,
    background: T.surface,
  },
  toolbarLeft: {
    display: "flex", alignItems: "center", gap: 10,
  },
  dateRangeLabel: {
    fontSize: 13, fontWeight: 600, color: T.textPrimary,
  },
  divider: {
    width: 1, height: 20, background: T.border,
  },
  recordCount: {
    fontSize: 12, color: T.textMuted,
  },

  legend: {
    display: "flex", alignItems: "center", gap: 16,
    padding: "8px 16px",
    borderBottom: `1px solid ${T.border}`,
    background: T.bg,
  },
  legendItem: { display: "flex", alignItems: "center", gap: 5 },
  legendText: { fontSize: 11, color: T.textSecondary },

  gridWrapper: {
    width: "100%",
    overflow: "auto",
    maxHeight: "70vh",
    userSelect: "none",
  },
  grid: {
    display: "grid",
    minWidth: "max-content",
  },

  leftSticky: {
    position: "sticky",
    left: 0,
    zIndex: 8,
  },

  cornerCell: {
    height: 38,
    background: T.surface,
    borderRight: `1px solid ${T.borderStrong}`,
    borderBottom: `1px solid ${T.border}`,
    position: "sticky",
    top: 0,
    zIndex: 12,
  },
  cornerCell2: {
    height: 40,
    background: T.surface,
    borderRight: `1px solid ${T.borderStrong}`,
    borderBottom: `1px solid ${T.border}`,
    position: "sticky",
    zIndex: 11,
  },
  monthHeader: {
    height: 38,
    background: T.surface,
    borderRight: `1px solid ${T.border}`,
    borderBottom: `1px solid ${T.border}`,
    display: "flex", alignItems: "center",
    paddingLeft: 12,
    fontSize: 12, fontWeight: 700,
    color: T.accent,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
    position: "sticky", top: 0, zIndex: 5,
  },
  dateHeader: {
    height: 40,
    background: T.surface,
    borderRight: `1px solid ${T.border}`,
    borderBottom: `2px solid ${T.borderStrong}`,
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    gap: 1,
    position: "sticky", top: 38, zIndex: 4,
  },
  weekendDate: {
    background: "#F8F9FB",
  },
  dateNum: {
    fontSize: 13, fontWeight: 700, color: T.textPrimary, lineHeight: 1,
  },
  dateDow: {
    fontSize: 9, fontWeight: 600, color: T.textMuted, letterSpacing: "0.06em", textTransform: "uppercase",
  },

  groupCell: {
    height: 50,
    background: T.groupBg,
    borderRight: `1px solid ${T.borderStrong}`,
    borderBottom: `1px solid ${T.borderStrong}`,
    display: "flex", alignItems: "center", gap: 10,
    padding: "0 12px 0 0",
    cursor: "pointer",
    overflow: "hidden",
  },
  groupStripe: {
    width: 3, alignSelf: "stretch", background: T.stripe, flexShrink: 0,
  },
  groupExpand: {
    fontSize: 10, color: T.textSecondary, flexShrink: 0,
  },
  groupName: {
    fontSize: 13, fontWeight: 700, color: T.textPrimary,
  },
  groupSub: {
    fontSize: 10, color: T.textMuted, marginTop: 1,
  },
  groupDateCell: {
    height: 50,
    background: T.groupBg,
    borderRight: `1px solid ${T.border}`,
    borderBottom: `1px solid ${T.borderStrong}`,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  availBadge: {
    fontSize: 11, fontWeight: 700, color: T.accent,
    background: T.accentLight, borderRadius: 3,
    padding: "1px 6px", border: `1px solid ${T.accentMid}`,
  },

  typePriceLabel: {
    height: 34,
    background: T.typePriceBg,
    borderRight: `1px solid ${T.borderStrong}`,
    borderBottom: `1px solid ${T.border}`,
    display: "flex", alignItems: "center", gap: 8,
    paddingLeft: 18,
  },
  priceRowBadge: {
    fontSize: 9, fontWeight: 700, color: T.accent,
    background: T.accentLight, borderRadius: 3,
    padding: "1px 5px", letterSpacing: "0.05em",
    border: `1px solid ${T.accentMid}`,
  },
  priceRowFull: {
    fontSize: 11, fontWeight: 600, color: T.textSecondary,
  },

  roomHeader: {
    height: 50,
    background: T.surface,
    borderRight: `1px solid ${T.borderStrong}`,
    borderBottom: `1px solid ${T.border}`,
    display: "flex", alignItems: "center", gap: 10,
    padding: "0 12px",
    borderLeft: `3px solid transparent`,
  },
  roomDot: {
    width: 6, height: 6, borderRadius: "50%",
    background: T.borderStrong, flexShrink: 0,
  },
  roomNo: {
    fontSize: 12, fontWeight: 700, color: T.textPrimary, letterSpacing: "0.02em",
  },
  roomId: {
    fontSize: 10, color: T.textMuted, marginTop: 2,
  },
  blankCell: {
    height: 50,
    background: T.surface,
    borderRight: `1px solid ${T.border}`,
    borderBottom: `1px solid ${T.border}`,
  },

  priceLabel: {
    height: 32,
    background: T.surface,
    borderRight: `1px solid ${T.borderStrong}`,
    borderBottom: `1px solid ${T.border}`,
    display: "flex", alignItems: "center", gap: 8,
    paddingLeft: 26,
  },
  priceRowBadge2: {
    fontSize: 9, fontWeight: 600, color: T.textMuted,
    background: "#F0F2F7", borderRadius: 3,
    padding: "1px 5px", letterSpacing: "0.05em",
    border: `1px solid ${T.border}`,
  },
  priceRowFull2: {
    fontSize: 11, fontWeight: 500, color: T.textSecondary,
  },

  priceCell: {
    height: 32,
    borderRight: `1px solid ${T.border}`,
    borderBottom: `1px solid ${T.border}`,
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    gap: 1,
    cursor: "crosshair",
    transition: "background 0.1s",
  },
  priceVal: {
    fontSize: 12, fontWeight: 600, color: T.textPrimary,
    fontVariantNumeric: "tabular-nums",
    letterSpacing: "-0.2px",
  },
  pctTag: {
    fontSize: 9, fontWeight: 700,
    borderRadius: 2, padding: "0 4px",
    border: "1px solid",
    lineHeight: "14px",
  },

  editDot: {
    position: "absolute",
    top: 3, right: 3,
    width: 5, height: 5,
    borderRadius: "50%",
    background: "#F59E0B",
    flexShrink: 0,
  },

  /* Modal meta */
  modalMeta: {
    background: T.bg, borderRadius: 6,
    border: `1px solid ${T.border}`,
    padding: "12px 16px",
    display: "flex", flexDirection: "column", gap: 8,
  },
  modalMetaRow: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
  },
  modalMetaLabel: {
    fontSize: 11, color: T.textMuted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em",
  },
  modalMetaVal: {
    fontSize: 12, color: T.textPrimary, fontWeight: 600,
  },
};

/* ─── Design Tokens ──────────────────────────────────────── */
